// Tax Amount Section Component
import React, { useState } from 'react';
import { CommonFlex, InputLabel } from '../../../styledComponents/common';
import {
  TaxAmountContainer,
  TaxAmountLabel,
  TaxAmountInputContainer,
  TaxAmountInput,
  TaxTypeToggleContainer,
  TaxTypeToggle,
} from '../invoiceStyles';
import { currencySymbolMap } from '../../../utils/currencies';

const TaxAmountSection = ({
  value,
  onChange,
  isPercentage,
  onTypeChange,
  currency,
  label = 'Tax Amount',
}) => {
  return (
    <TaxAmountContainer>
      <TaxAmountLabel>{label}</TaxAmountLabel>
      <TaxAmountInputContainer>
        <TaxAmountInput
          type="number"
          min="0"
          placeholder="Enter amount"
          value={value}
          onChange={onChange}
          onWheel={e => e.target.blur()}
        />
        <TaxTypeToggleContainer>
          <TaxTypeToggle
            active={isPercentage}
            onClick={() => onTypeChange(true)}
          >
            %
          </TaxTypeToggle>
          <TaxTypeToggle
            active={!isPercentage}
            onClick={() => onTypeChange(false)}
          >
            {currency?.value ? currencySymbolMap[currency.value] : '$'}
          </TaxTypeToggle>
        </TaxTypeToggleContainer>
      </TaxAmountInputContainer>
    </TaxAmountContainer>
  );
};

export default TaxAmountSection;
